import { useEffect } from 'react'

function isNumberInput(target: EventTarget | null): target is HTMLInputElement {
  return target instanceof HTMLInputElement && target.type === 'number'
}

/** Prevent keyboard arrows & mouse wheel from changing number input values (admin UX). */
export function useBlockNumberInputSteppers() {
  useEffect(() => {
    const blockArrowStep = (e: KeyboardEvent) => {
      if (!isNumberInput(e.target)) return
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault()
      }
    }

    const blockWheelStep = (e: WheelEvent) => {
      if (!isNumberInput(e.target)) return
      if (document.activeElement === e.target) {
        e.preventDefault()
      }
    }

    document.addEventListener('keydown', blockArrowStep, true)
    document.addEventListener('wheel', blockWheelStep, { capture: true, passive: false })
    return () => {
      document.removeEventListener('keydown', blockArrowStep, true)
      document.removeEventListener('wheel', blockWheelStep, true)
    }
  }, [])
}
